import React, { useState, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";
import { Info } from "react-feather";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import "./QuantSection.css";

const QuantSection = ({ data, plantCount }) => {
  const metrics = [
    { key: "plant_count", label: "Plants" },
    { key: "est_capacity_tons", label: "Capacity" },
    { key: "capex_usd_millions", label: "CapEx" },
    { key: "logistics_cost_percent", label: "Logistics" },
    { key: "inventory_days", label: "Inventory" },
    { key: "import_dependency_percent", label: "Imports" },
    { key: "export_share_percent", label: "Exports" },
    { key: "plants", label: "Plants" },
    { key: "capacity", label: "Capacity" },
    { key: "capex", label: "CapEx" },
    { key: "logistics", label: "Logistics" },
    { key: "inventory", label: "Inventory" },
    { key: "imports", label: "Imports" },
    { key: "exports", label: "Exports" },
  ];

  const [show, setShow] = useState(null);
  const targetRefs = useRef({});
  const timeoutRef = useRef(null);

  const handleEnter = (idx) => {
    clearTimeout(timeoutRef.current);
    setShow(idx);
  };

  const handleLeave = () => {
    timeoutRef.current = setTimeout(() => setShow(null), 200); // small delay feels smoother
  };

  return (
    <div className="quant_snapshot_wrapper">
      <h2 className="quant_head">Quantitative Snapshot</h2>

      <div className="quant_box_block">
        {metrics.map((metric, idx) => {
          // const metricData = data[metric.key];
          const metricData =
            data[metric.key] ?? data?.[0]?.response?.metrics?.[metric.key];
          // if (!metricData) return null;
          if (
            !metricData ||
            (metric.label.toLowerCase() === "plants"
              ? plantCount === 0
              : Number(metricData?.value) === 0)
          ) {
            return null;
          }
          return (
            <div key={idx} className="quant_box">
              <div className="quant_box_head">{metric.label}</div>

              <div className="quant_box_number">
                {metric.label.toLowerCase() === "PLANTS".toLowerCase()
                  ? plantCount
                  : metricData?.value.toLocaleString()}{" "}
                {/* {metricData?.value.toLocaleString()}{" "} */}
                {metricData?.sources?.length > 0 && (
                  <>
                    <span
                      ref={(el) => (targetRefs.current[idx] = el)}
                      onMouseEnter={() => handleEnter(idx)}
                      onMouseLeave={handleLeave}
                      style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <Info size={12} color="#6b7280" />
                    </span>

                    <Overlay
                      target={targetRefs.current[idx]}
                      show={show === idx}
                      placement="top"
                    >
                      <Popover
                        id={`popover-${idx}`}
                        style={{
                          maxWidth: "250px",
                          fontSize: "12px",
                          padding: "8px",
                        }}
                        onMouseEnter={() => handleEnter(idx)}
                        onMouseLeave={handleLeave}
                      >
                        <Popover.Body>
                          <strong>Source:</strong>
                          {metricData.sources.map((src, sIdx) => (
                            <div
                              key={sIdx}
                              style={{
                                marginBottom: "4px",
                                wordBreak: "break-all",
                              }}
                            >
                              <br />
                              {/* <ParsedTextWithLinks text={src?.url} /> */}
                              <a href={src?.url} target="_blank">
                                {src?.title}
                              </a>
                            </div>
                          ))}
                        </Popover.Body>
                      </Popover>
                    </Overlay>
                  </>
                )}
              </div>
              <div className="sub_text">{metricData.unit}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuantSection;
